<template>
  <div class="page-header-index-wide">
    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <div class="extra-wrapper" slot="tabBarExtraContent">
            <div class="extra-item">
              <a :class="selectedDateType===1 ? 'a-selected': ''" @click="selectDate(1)">今日</a>
              <a :class="selectedDateType===2 ? 'a-selected': ''" @click="selectDate(2)">本周</a>
              <a :class="selectedDateType===3 ? 'a-selected': ''" @click="selectDate(3)">本月</a>
              <a :class="selectedDateType===4 ? 'a-selected': ''" @click="selectDate(4)">本年</a>
            </div>
            <a-range-picker v-model="selectedDateRange" :style="{width: '256px'}" @change="onDateChange" />
          </div>
          <a-tab-pane loading="true" tab="业绩统计" key="1">
            <a-row>
              <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="去税佣金(单位：元)" :dataSource="brokerageData"/>
              </a-col>
              <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="去税保费(单位：元)" :dataSource="premiumData"/>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <pie title="佣金占比" :height="360" :dataSource="pieData"></pie>
              </a-col>
              <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list title="去税佣金排行榜(单位：元)" :list="rankList"/>
                <label style="margin-left:75px;">总计：{{cleanBrokerageSum}}</label>
              </a-col>

            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>

    <a-row>
      <a-col :span="24">
        <a-card :loading="loading" :bordered="false" title="业绩趋势" :style="{ marginTop: '24px' }">
          <a-row>
            <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
              <line-chart-base title="公司业绩(单位：元)" :height="360"  :dataSource="trendData"></line-chart-base>
              <!--<bar title="佣金" :dataSource="brokerageData"/>-->
            </a-col>
            <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
              <line-chart-multid title="业绩对比(单位：元)" :height="360" :fields="comparisonFields" :dataSource="comparisonData"></line-chart-multid>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import moment from 'moment'
  import ChartCard from '@/components/ChartCard'
  import ACol from "ant-design-vue/es/grid/Col"
  import ARow from 'ant-design-vue/es/grid/Row'
  import RankList from '@/components/chart/RankList'
  import Bar from '@/components/chart/Bar'
  import Pie from '@/components/chart/Pie'
  import LineChartBase from '@/components/chart/LineChartBase'
  import LineChartMultid from '@/components/chart/LineChartMultid'
  import { getAction} from '@/api/manage'
  import {toDecimal, padRightAndFormatter} from '@/utils/util'

  export default {
    name: "IndexChart",
    components: {
    ARow,
    ACol,
    ChartCard,
    RankList,
    Bar,
    Pie,
    LineChartBase,
    LineChartMultid,
},
    data() {
      return {
        loading: true,
        center: null,
        selectedDateType: 3, //日期类型:1今日2本周3本月4本年 5日期区间
        selectedDateRange:[], //选择日期区间
        achievementData: [],
        rankList: [], //净佣金排行
        brokerageData: [], // 佣金
        premiumData: [], // 保费
        pieData: [],
        trendData:[],
        comparisonFields:[],
        comparisonData:[], //业绩对比数据
        cleanBrokerageSum: 0.0, //净佣金合计
        indicator: '<a-icon type="loading" style="font-size: 24px" spin />',
        url:{
          getBusinessDep:'/sys/sysDepart/getBusinessDep', // 获取业务部门
          getAchievementData:'/bms/homePage/jiuBaDate', //业绩
          trendByMonth:'/bms/homePage/trendByMonth', // 业绩趋势
          getComparisonData:'/bms/homePage/trendContrast', // 业绩对比
        },
        businessDep:{}, // 业务部门
      }
    },
    created() {
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
      this.initBusinessDep();
      this.getAchievementData();
      this.getTrendByMonth();
      this.getComparisonData();
    },
    methods: {
      // 查询业务部门
      initBusinessDep(){
        getAction(this.url.getBusinessDep,{}).then((res)=>{
          if(res.success){
            this.businessDep = res.result;
          }else{
            this.$message.warning("获取部门失败")
          }
        })
      },
      //获取业绩数据
      getAchievementData(){
        let startDate = '', endDate ='';
        let today = moment(new Date()).format('YYYY-MM-DD');
        let startTime = ' 00:00:00';
        let endTime = ' 23:59:59';

        if(this.selectedDateType===1){ //今日
          startDate = today + startTime;
          endDate = today + endTime;
        } else if(this.selectedDateType ===2){//本周
          let weekFirstDay = moment().startOf('isoWeek').format('YYYY-MM-DD');
          startDate = weekFirstDay + startTime;//本周第一天
          endDate = today + endTime;
        } else if(this.selectedDateType ===3){//本月
          let monthFirstDay = moment().startOf('month').format('YYYY-MM-DD');
          startDate = monthFirstDay + startTime;//本月第一天
          endDate = today + endTime;
        } else if(this.selectedDateType ===4){//本年
          let yearFirstDay = moment().startOf('year').format('YYYY-MM-DD');
          startDate = yearFirstDay + startTime;//本年第一天
          endDate = today + endTime;
        } else if(this.selectedDateType ===5){//日期区间
          startDate = this.selectedDateRange[0] + startTime;//本月第一天
          endDate = this.selectedDateRange[1] + endTime;
        }

        getAction(this.url.getAchievementData,{startDate: startDate, endDate: endDate}).then((res)=>{
          if(res.success){
            this.achievementData = res.result;
            this.setShapeData();
          }else{
            this.$message.warning("获取业绩失败")
          }
        })
      },

      //对查询结果排序，
      sortArray(array, key){
        array.sort((s1, s2) =>{
          if(s1[key] > s2[key]){
            return -1;
          } else if(s1[key] === s2[key]){
            return 0;
          } else {
            return 1;
          }
        })
      },
      setShapeData(){
        this.brokerageData = []
        this.premiumData = []
        this.pieData = []
        this.rankList = []
        for (let i = 0; i < this.businessDep.length; i++) {
          this.brokerageData.push({
            x: this.businessDep[i].departNameAbbr,
            y: this.getBrokerageByOrgCode(this.businessDep[i].orgCode)
          })
          this.premiumData.push({
            x: this.businessDep[i].departNameAbbr,
            y: this.getPremiumByOrgCode(this.businessDep[i].orgCode)
          })

          this.pieData.push({
            item: this.businessDep[i].departNameAbbr,
            count: this.getBrokerageByOrgCode(this.businessDep[i].orgCode)
          })

          this.rankList.push({
            name: this.businessDep[i].departNameAbbr,
            total: this.getBrokerageByOrgCode(this.businessDep[i].orgCode)
          })
        }
        this.sortArray(this.brokerageData, 'y');
        this.sortArray(this.premiumData, 'y');
        this.sortArray(this.pieData, 'count');
        this.sortArray(this.rankList, 'total');

        //格式化rankList数据 1,000,000.00格式, 非viser图形，自定义格式化; 同时求合计
        this.cleanBrokerageSum = 0.0
        this.rankList.forEach(obj=>{
          this.cleanBrokerageSum = this.cleanBrokerageSum + obj.total
          obj.total = padRightAndFormatter(obj.total)          
        })
        this.cleanBrokerageSum = padRightAndFormatter(this.cleanBrokerageSum)
      },

      //根据部门编号获取佣金
      getBrokerageByOrgCode(orgCode){
        let value = 0
        if(this.achievementData.brokerage != null && this.achievementData.brokerage[orgCode] != null){
          value = toDecimal(this.achievementData.brokerage[orgCode]);
        }
        return value;
      },
      getPremiumByOrgCode(orgCode){
        let value = 0
        if(this.achievementData.premium != null && this.achievementData.premium[orgCode] != null){
          value = toDecimal(this.achievementData.premium[orgCode]);
        }
        return value;
      },
      selectDate(no){
        this.selectedDateType = no;
        //清空日期控件的值
        this.selectedDateRange =[];
        //重新查询数据
        this.getAchievementData();
      },
      onDateChange(value, dateString) {
        this.selectedDateRange = dateString;
        this.selectedDateType = 5;
        //重新查询数据
        this.getAchievementData();
      },

      // 获取趋势数据
      getTrendByMonth(){
        let that = this;
        getAction(this.url.trendByMonth,{}).then(res=>{
          if(res.success){
            that.setTrendData(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setTrendData(trendData){
        for(let item of trendData){ // 返回的是数组
          this.trendData.push({
            item: item.part + '月',
            value: toDecimal(item.brokerage)
          })
        }
        // 从小往大排序
        // this.trendData.sort((s1,s2) =>{
        //   if(s1.item < s2.item){
        //     return -1;
        //   } else if(s1.item === s2.item){
        //     return 0;
        //   } else {
        //     return 1;
        //   }
        // })
      },

      getComparisonData(){
        let that = this;
        getAction(this.url.getComparisonData,{}).then(res=>{
          if(res.success){
            that.setComparisonData(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setComparisonData(comparisonData){
        //设置折线图数据
        this.comparisonFields = []
        this.comparisonFields.push("本月")
        this.comparisonFields.push("上月")
        this.comparisonData = [];
        let thisMonthSum = 0, lastMonthSum = 0;
        let typeItem = 0;
        for(let i=0; i<6; i++){ //确定返回6个元素
          thisMonthSum += comparisonData.thisMonth[i].brokerage;
          lastMonthSum += comparisonData.lastMonth[i].brokerage;
          typeItem = (i+1) * 5 + '天';
          if(i == 5){
            typeItem = '月底'
          }
          this.comparisonData.push({
            "本月": toDecimal(thisMonthSum),
            "上月": toDecimal(lastMonthSum),
            type: typeItem
          })
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  /*.circle-cust{*/
    /*position: relative;*/
    /*top: 28px;*/
    /*left: -100%;*/
  /*}*/
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }
  .a-selected{
    color: #fff;
    background-color: #1890FF;
  }
</style>